import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { NavButton } from '../navigation/nav'
import { Button, Menu, MenuItem } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export const PromoBlockHSBC = ({ children, buttonText, inverted, onModalOpen, withMenu = false }) => {
  const { t } = useTranslation()
  const btn = useRef(null)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = r => {
    setAnchorEl(r.currentTarget)
  }

  const handleClose = route => {
    if (route) {
      navigate(route)
    }
    setAnchorEl(null)
  }

  const navigate = useNavigate()

  return (
    <div className=''>
      <div
        className={`column column-center ${inverted ? ' row-reverse' : ''} space-between mob-column `}
        style={{ backgroundColor: '#ffffff' }}
      >
        <div className='column column-center mob-text-center mob-column-center promo-block'>
          {children ? (
            children
          ) : (
            <p className='mb36 sato36 font500 mob-font-24'>
              {t('An all-new platform.')}
              <br />
              {t('An all-new world for security teams.')}
            </p>
          )}
          {buttonText && !withMenu && (
            <NavButton
              onClick={onModalOpen}
              to='https://admin.gallaghercdc.cyberlift.ai/login'
              variant='dark'
              size='md'
            >
              {buttonText}
            </NavButton>
          )}

          {withMenu && (
            <Button
              sx={{
                background: '#0075BC',
                borderRadius: 0,
                padding: '22px 35px',
                letterSpacing: 1.6,
                cursor: 'pointer',
                color: '#fff',
                '&:hover': {
                  background: '#336791'
                }
              }}
              ref={btn}
              onClick={handleClick}
              variant='dark'
              size='md'
            >
              Book a demo
            </Button>
          )}
          <Menu
            sx={{ '& .MuiPaper-root': { width: btn.current?.offsetWidth || '400px', maxWidth: '400px' } }}
            id='basic-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={() => handleClose()}
            slotProps={{
              list: {
                'aria-labelledby': 'basic-button'
              }
            }}
          >
            <MenuItem onClick={() => handleClose('/activate/hsbc')}>UK</MenuItem>
          </Menu>

          <div className='hide mob-show' style={{ height: 30 }}></div>
        </div>
      </div>
    </div>
  )
}
